import { apiUrl } from '../config/api'

function getAuthHeader() {
    const secret = localStorage.getItem('x-auth-secret')
    return secret ? { 'x-auth-secret': secret } : {}
}

export async function listShopDues() {
    const resp = await fetch(apiUrl('/api/admin/shop-dues'), {
        headers: { ...getAuthHeader(), 'Accept': 'application/json' }
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to fetch shop dues')
    return resp.json()
}

export async function listShopOrders(shopId) {
    const resp = await fetch(apiUrl(`/api/admin/shop-dues/${shopId}/orders`), {
        headers: { ...getAuthHeader(), 'Accept': 'application/json' }
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to fetch shop orders')
    return resp.json()
}

export async function collectShopDues(shopId) {
    const resp = await fetch(apiUrl(`/api/admin/shop-dues/${shopId}/collect`), {
        method: 'POST',
        headers: { ...getAuthHeader(), 'Accept': 'application/json' }
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to collect shop dues')
    return resp.json()
}
